"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var path_1 = require("../../utils/shopify/path");
var color_1 = require("../common/color");
var banner_1 = require("../../utils/shopify-graphql/banner");
var Banner = function () {
    var _a = (0, hooks_1.useState)(function () {
        var endTime = new Date(window.sessionStorage.getItem('timer') || Date.now() + 40 * 60000);
        //update current time in local storage
        window.sessionStorage.setItem('timer', endTime.toString());
        //calculate difference between last seen time and current time for use in setInterval
        var timeDifference = (endTime.getTime() - Date.now()) / 1000;
        return timeDifference;
    }), timeRemaining = _a[0], setTimeRemaining = _a[1];
    var _b = (0, hooks_1.useState)(false), newVisitor = _b[0], setNewVisitor = _b[1];
    var _c = (0, hooks_1.useState)(null), bannerData = _c[0], setBannerData = _c[1];
    var minutes = Math.trunc(timeRemaining / 60);
    var seconds = Math.trunc(timeRemaining % 60);
    var isWillo = bannerData === null || bannerData === void 0 ? void 0 : bannerData.color.includes('willo');
    (0, hooks_1.useEffect)(function () {
        //force color state to allow banner render for pages without banner metaobject
        var handle = location.pathname.split('/')[2];
        var pathType = (0, path_1.getPathType)(location);
        //set banner data for home page since it is not of pathType types, will not be queried
        if (!pathType) {
            setBannerData({ color: 'op-orange' });
        }
        else {
            (0, banner_1.getBannerData)(handle, pathType)
                .then(function (d) { return setBannerData(d); })
                .catch(function (err) { return console.error(err); });
        }
    }, []);
    //start async countdown with 1s interval
    (0, hooks_1.useEffect)(function () {
        var cookie = {};
        //parse through document and push each cookie into array
        document.cookie.split(';').forEach(function (el) {
            var splitCookie = el.split('=');
            var key = splitCookie[0].trim();
            var value = splitCookie[1];
            cookie[key] = value;
        });
        try {
            //extract unix timestamp of ga cookie
            var cookieDate = cookie['_ga'].substring(cookie['_ga'].length - 10);
            var timeDiff = Math.floor(Date.now() / 1000) - parseInt(cookieDate);
            //if time between cookie set and current date is more than 40, they are returning visitor
            if (timeDiff < 2400) {
                setNewVisitor(true);
            }
            else {
                setNewVisitor(false);
            }
        }
        catch (e) {
            setNewVisitor(true);
            console.error(e);
        }
        if (window.localStorage.getItem('bannerEnd') !== 'true') {
            var startBannerTimer_1 = setInterval(function () {
                var time = timeRemaining;
                setTimeRemaining(function (prev) {
                    time = prev - 1;
                    return time;
                });
                //clear interval at 0:00 or less (if they leave the website and return while time hits 0:00) and run side effects
                if (time <= 0) {
                    //replacement for context to trigger state change, dispatch event for IntroOfferBtn to listen
                    window.dispatchEvent(new Event('bannerEnd'));
                    window.localStorage.setItem('bannerEnd', 'true');
                    clearInterval(startBannerTimer_1);
                }
            }, 1000);
        }
    }, []);
    if (!bannerData) {
        return (0, preact_1.h)(preact_1.Fragment, null);
    }
    return ((0, preact_1.h)("article", { class: "banner__carousel", style: { background: "".concat((0, color_1.toHex)(bannerData.color)) } },
        (0, preact_1.h)("div", { class: "banner" },
            (0, preact_1.h)("a", { href: location.pathname == '/' ? '/collections/shop-all' : '#anchor--product-title', class: "banner__link text--white" },
                (0, preact_1.h)("p", { class: "banner__timer" }, newVisitor && timeRemaining > 0 ? ((0, preact_1.h)("span", { class: "banner__content" },
                    (0, preact_1.h)("span", { class: "banner__timer-minute" },
                        "ONLY ",
                        minutes < 10 ? '0' + minutes : minutes,
                        ":",
                        seconds < 10 ? '0' + seconds : seconds,
                        ' '),
                    "to get ",
                    (0, preact_1.h)("b", null, "25% OFF!"),
                    " ",
                    (0, preact_1.h)("br", null),
                    "Use Code ",
                    (0, preact_1.h)("b", null, "NEW25"),
                    ' ',
                    (0, preact_1.h)("b", null,
                        (0, preact_1.h)("u", null, "Shop Now"),
                        " \u203A"))) : ((0, preact_1.h)("span", { class: "banner__content" },
                    "Get ",
                    (0, preact_1.h)("strong", null, "15% OFF"),
                    " with code ",
                    (0, preact_1.h)("b", null, "15OFF"),
                    " ",
                    (0, preact_1.h)("u", null, "Shop Now \u203A"))))))));
};
exports.default = Banner;
